/* assets/shop-by-location.js */
(function() {
  if (typeof window === 'undefined') return;

  var DESKTOP_MIN = 769;

  function isDesktop() { return window.innerWidth >= DESKTOP_MIN; }

  function wantSlider(root) {
    var desktop = root.getAttribute('data-slider-desktop') === 'true';
    var mobile  = root.getAttribute('data-slider-mobile') === 'true';
    return isDesktop() ? desktop : mobile;
  }

  function mount(root) {
    if (!root || root.__splide) return;
    try {
      root.__splide = new Splide(root);
      root.__splide.mount();
    } catch (e) { console && console.warn && console.warn('Splide mount error:', e); }
  }

  function destroy(root) {
    if (root && root.__splide && typeof root.__splide.destroy === 'function') {
      root.__splide.destroy(true);
      root.__splide = null;
    }
  }

  function setGrid(root) {
    // Ensure content is visible when not using Splide
    destroy(root);
    root.classList.add('is-grid');
    root.style.visibility = 'visible'; // overrides Splide's default hidden
  }

  function setSlider(root) {
    // Let Splide manage visibility
    root.classList.remove('is-grid');
    root.style.visibility = ''; // clear our override so Splide can toggle
    mount(root);
  }

  function applyMode(root) {
    if (!root) return;
    if (wantSlider(root)) setSlider(root);
    else setGrid(root);
  }

  function wire(scope) {
    (scope || document)
      .querySelectorAll('.location-section .splide[data-splide]')
      .forEach(function(root) {
        if (root.__wired) return;
        root.__wired = true;

        var onResize = function() { applyMode(root); };
        window.addEventListener('resize', onResize);
        root.__cleanup = function() { window.removeEventListener('resize', onResize); };

        // Initial mode
        applyMode(root);
      });
  }

  document.addEventListener('DOMContentLoaded', function() { wire(document); });

  // Theme editor lifecycle
  document.addEventListener('shopify:section:load', function(e) { wire(e.target); });
  document.addEventListener('shopify:section:unload', function(e) {
    e.target.querySelectorAll('.location-section .splide[data-splide]').forEach(function(root) {
      destroy(root);
      if (root.__cleanup) root.__cleanup();
      root.__wired = false;
    });
  });
})();
